import React, { useEffect, useContext, useState, Suspense } from 'react'
import { Route, BrowserRouter as Router, withRouter, Switch } from 'react-router-dom'
import PrivateRoute from './privateRoute'
import Loaders from '@/custom/components/molecules/Loaders'
import AppointmentManage from '../views/Dashboard/Appointment/AppointmentManage'
const PaymentSuccess = React.lazy(() => import('@/views/Checkout/PaymentSuccess'))
import Subscription from '../views/Subscription/index_skyflow'
import Home from '../views/Home'
import Maintanence from '@/product/components/organisms/Maintanence'
import RegisterSuccess from '@/views/Registration/RegisterSuccess'
import RegisterSellerSuccess from '@/views/Registration/RegisterSuccessSeller'
import MyPickup from '@/views/PickUp'
import MyAccountMain from '@/views/Dashboard/MyAccountMain'
import SavedCard from '@/views/Dashboard/SavedCard'
import PasswordSecurity from '@/views/Dashboard/PasswordSecurity'
import Myaccount from '@/views/Dashboard/Profile/Myaccount'

const UserView = React.lazy(() => import('@/views/Seller/Organization/UserView'))
const SellerMyAuctions = React.lazy(() => import('@/views/Seller/Dashboard/AuctionLots/dynamic'))
const AuctionType = React.lazy(() => import('@/views/Seller/PostProject/AuctionType'))
const Bank = React.lazy(() => import('@/views/Seller/Dashboard/Bank'))
const SwitchUser = React.lazy(() => import('@/product/views/SwitchUser'))
const SellerListing = React.lazy(() => import('@/views/Seller/Dashboard/Listing/dynamic'))
const Reports = React.lazy(() => import('@/views/Seller/Report'))
const MyCardDetails = React.lazy(() => import('@/views/Seller/Dashboard/MyCardDetails'))
const CreateLot = React.lazy(() => import('@/views/Seller/PostProject/CreateLot'))
const Login = React.lazy(() => import('@/views/Login/login'))
const ForgotPassword = React.lazy(() => import('@/views/ForgotPassword'))
const ResetPassword = React.lazy(() => import('@/views/ResetPassword'))
const Search = React.lazy(() => import('@/views/Search'))
const MyAuctions = React.lazy(() => import('@/views/Dashboard/MyAuctions'))
const MyOrders = React.lazy(() => import('@/views/Dashboard/MyOrders'))
const Registration = React.lazy(() => import('@/views/Registration'))
const SellerRegistration = React.lazy(() => import('@/views/Registration/Seller'))
const Profile = React.lazy(() => import('@/views/Dashboard/Profile/index'))
const ChangePassword = React.lazy(() => import('@/views/Dashboard/Profile/ChangePassword'))
const MyInvoices = React.lazy(() => import('@/views/Dashboard/MyInvoices'))
const MyDeposits = React.lazy(() => import('@/views/Dashboard/MyDeposits'))
const MyTransactions = React.lazy(() => import('@/views/Dashboard/MyTransactions'))
const MyInterests = React.lazy(() => import('@/views/Dashboard/MyInterests'))
const Invoice = React.lazy(() => import('@/views/Invoice'))
const Interest = React.lazy(() => import('@/views/Dashboard/Interest'))
const SellerInvoice = React.lazy(() => import('@/views/Invoice/SellerInvoice'))
const SellerReturnInvoice = React.lazy(() => import('@/views/Invoice/SellerReturnInvoice'))
const DepositInvoice = React.lazy(() => import('@/views/DepositInvoice'))
const LiveAuction = React.lazy(() => import('@/views/ProductView/LiveAuction'))
const ProductViewSingle = React.lazy(() => import('@/views/ProductView'))
const ProductViewInvite = React.lazy(() => import('@/views/ProductView/ProductView_Invite'))
const Cart = React.lazy(() => import('@/views/NewCart/NewCartIndex'))
const BuynowCart = React.lazy(() => import('@/views/BuyNowCart'))
const MyCart = React.lazy(() => import('@/views/Dashboard/MyCart'))
const Checkout = React.lazy(() => import('@/views/Checkout'))
const CheckoutSuccess = React.lazy(() => import('@/views/Checkout/CheckoutSuccess'))
const MyWallet = React.lazy(() => import('@/views/Dashboard/MyWallet'))
const MySubscription = React.lazy(() => import('@/views/Seller/Dashboard/MySubscription'))
const ErrorPage = React.lazy(() => import('@/views/ErrorPage'))
const Auction = React.lazy(() => import('@/views/Auction'))
const VerifyEmail = React.lazy(() => import('@/views/VerifyEmail'))
const AuctionTemplates = React.lazy(() => import('@/views/Seller/Template/Auction/dynamic'))
const ProductTemplates = React.lazy(() => import('@/views/Seller/Template/Product/dynamic'))
const Notifications = React.lazy(() => import('@/views/Dashboard/Profile/Notifications'))
const ContactUs = React.lazy(() => import('@/views/ContactUs'))
const StaticPage = React.lazy(() => import('@/views/Static'))
const SavedSearch = React.lazy(() => import('@/views/Dashboard/SavedSearch'))
const RosoomResponse = React.lazy(() => import('@/views/Rosoom/Response'))
// const MyCard = React.lazy(() => import('@/views/Dashboard/MySkyflowCard'))
const MyCard = React.lazy(() => import('@/views/Dashboard/MyCard'))
const MyBank = React.lazy(() => import('@/views/Dashboard/MyBank'))
const Offers = React.lazy(() => import('../views/Dashboard/Offers'))
const MakeofferCart = React.lazy(() => import('../views/MakeOfferCart'))
const Checkin = React.lazy(() => import('@/views/Dashboard/MyOrders/Checkin'))

const Message = React.lazy(() => import('@/views/Message'))
const SellerDashboard = React.lazy(() => import('@/views/Seller/Dashboard'))
const Warehouse = React.lazy(() => import('@/views/Seller/Warehouse'))
const Transaction = React.lazy(() => import('@/views/Seller/Transaction'))
const Users = React.lazy(() => import('@/views/Seller/Users'))
const Invoices = React.lazy(() => import('@/views/Seller/Invoices'))
const ERP = React.lazy(() => import('@/views/Seller/ERP'))
const Pickup = React.lazy(() => import('@/views/Seller/Pickup'))
const Order = React.lazy(() => import('@/views/Order'))
const Location = React.lazy(() => import('@/views/Location'))
const Buying = React.lazy(() => import('@/views/Buying'))

const Routes = () => {
    return (
        <>
            <Maintanence ipAddress={null} />
            <Suspense fallback={<Loaders name="home" isLoading={true} />}>
                <Switch>
                    <Route exact path="/">
                        <Home homePage={true} />
                    </Route>
                    <Route exact path="/search" component={Home} />
                    <Route exact path="/maintanence" />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/signup" component={Registration} />
                    <Route exact path="/success" component={RegisterSuccess} />
                    <Route exact path="/seller/success" component={RegisterSellerSuccess} />
                    <Route exact path="/forgot_password" component={ForgotPassword} />
                    <Route exact path="/reset_password/:token" component={ResetPassword} />
                    <Route exact path="/registration">
                        <Registration multiform={false} />
                    </Route>
                    <Route exact path="/seller/registration">
                        <SellerRegistration multiform={false} />
                    </Route>
                    <Route exact path="/liveAuction/:aid" component={LiveAuction} />
                    <Route exact path="/auction" component={Auction} />
                    <Route exact path="/invite" component={ProductViewInvite} />
                    <Route exact path="/product-view/:id" component={ProductViewSingle} />
                    <Route exact path="/productView/:id" component={ProductViewSingle} />
                    <Route exact path="/my_interest" component={Interest} />
                    <Route exact path="/contact-us" component={ContactUs} />
                    <PrivateRoute exact path="/my-account/personal" component={Myaccount} />
                    <PrivateRoute exact path="/my-account/password" component={PasswordSecurity} />
                    <PrivateRoute exact path="/my-account/savedCard" component={SavedCard} />
                    <PrivateRoute exact path="/my-account/saved_search" component={SavedSearch} />
                    <PrivateRoute exact path="/myoffers" component={MakeofferCart} />
                    <Route exact path="/verify_email/:token" component={VerifyEmail} />
                    <PrivateRoute exact path="/alloffers" component={Offers} />
                    <PrivateRoute exact path="/buynowcart" component={BuynowCart} />
                    <PrivateRoute exact path="/checkout/:type/:cart_id" component={Checkout} />
                    <PrivateRoute exact path="/payment-success/:id" component={CheckoutSuccess} />
                    <PrivateRoute exact path="/cart" component={Cart} />
                    <PrivateRoute exact path="/offers/:type" component={MyAuctions} />
                    <PrivateRoute exact path="/favorites/:type" component={MyAuctions} />
                    <PrivateRoute exact path="/purchases/:type" component={MyAuctions} />
                    <PrivateRoute exact path="/my-orders" component={MyOrders} />
                    <PrivateRoute exact path="/checkin/:invoiceid" component={Checkin} />
                    <PrivateRoute exact path="/schedule/:action" component={MyPickup} />
                    <PrivateRoute exact path="/my-account" component={MyAccountMain} />
                    <PrivateRoute exact path="/account/profile" component={Myaccount} />
                    <PrivateRoute exact path="/shopping-cart" component={MyCart} />
                    <PrivateRoute exact path="/my-account/my-interests" component={MyInterests} />
                    <PrivateRoute exact path="/account/change" component={ChangePassword} />
                    <PrivateRoute
                        exact
                        path="/my-account/notifications"
                        component={Notifications}
                    />
                    {/* <PrivateRoute exact path="/company_profile" component={CompanyProfile} /> */}
                    <PrivateRoute exact path="/invoices/:action" component={MyInvoices} />
                    <PrivateRoute exact path="/payments/transactions" component={MyTransactions} />
                    <PrivateRoute exact path="/invoice/:id" component={Invoice} />
                    <PrivateRoute
                        exact
                        path="/return/invoice/:id"
                        component={SellerReturnInvoice}
                    />
                    <PrivateRoute
                        exact
                        path="/seller/invoice/:id/:user_id"
                        component={SellerInvoice}
                    />
                    <PrivateRoute
                        exact
                        path="/seller/return/invoice/:id/:user_id"
                        component={SellerReturnInvoice}
                    />
                    <PrivateRoute exact path="/depositinvoice/:id" component={DepositInvoice} />
                    <PrivateRoute exact path="/deposits/:action" component={MyDeposits} />
                    <PrivateRoute exact path="/payments/saved_cards" component={MyCard} />
                    <PrivateRoute exact path="/payments/bank_details" component={MyBank} />
                    <PrivateRoute exact path="/wallet" component={MyWallet} />
                    <PrivateRoute exact path="/rosoom_success" component={RosoomResponse} />
                    <Route exact path="/seller/dashboard" component={SellerDashboard} />
                    <Route exact path="/seller/templates" component={AuctionTemplates} />
                    <Route exact path="/seller/product/templates" component={ProductTemplates} />
                    <Route exact path="/payments/subscription" component={MySubscription} />
                    <Route exact path="/seller/organization" component={UserView} />
                    <Route exact path="/appointment/schedule/:id" component={AppointmentManage} />
                    <Route exact path="/seller/reports" component={Reports} />
                    <PrivateRoute exact path="/seller/erp-tool/:action" component={ERP} />
                    <PrivateRoute exact path="/seller/pickup/:action" component={Pickup} />
                    <Route exact path="/seller/transactions" component={Transaction} />
                    <Route exact path="/seller/warehouse-locations" component={Warehouse} />
                    <Route exact path="/seller/users/:action" component={Users} />
                    <PrivateRoute exact path="/seller/invoices/:action" component={Invoices} />
                    <Route
                        exact
                        path="/post_project/auction_detail/:action"
                        component={AuctionType}
                    />
                    <Route exact path="/otpredirect" component={PaymentSuccess} />
                    <Route exact path="/post_project/create_lot/:action" component={CreateLot} />
                    <PrivateRoute
                        exact
                        path="/seller/auctions/:action"
                        component={SellerMyAuctions}
                    />
                    <Route exact path="/switch" component={SwitchUser} />
                    <PrivateRoute exact path="/seller/listing/:action" component={SellerListing} />
                    <PrivateRoute exact path="/seller/payments/bank_details" component={Bank} />
                    <PrivateRoute exact path="/seller/ordercontrol/:action" component={Order} />
                    <PrivateRoute
                        exact
                        path="/seller/payments/saved_cards"
                        component={MyCardDetails}
                    />
                    <PrivateRoute exact path="/messages" component={Message} />
                    <Route exact path="/locationmap" component={Location} />
                    <Route exact path="/buying" component={Buying} />
                    <Route
                        exact
                        path={[
                            '/about-us',
                            '/services',
                            '/help',
                            '/guidelines',
                            '/privacy_policy',
                            '/privacy-policy',
                            '/terms-and-conditions',
                            '/locations',
                            '/faq',
                            '/sell',
                            '/terms',
                            '/sales/today',
                            '/sales',
                            '/sales/popular',
                            '/bids',
                            '/glossary',
                            '/sales/map',
                        ]}
                        component={StaticPage}
                    />
                    <Route exact path="/subscription" component={Subscription} />
                    <Route exact path="*" component={ErrorPage} />
                </Switch>
            </Suspense>
            {/* <Suspense fallback={<Loaders name="home" />}> */}
            {/* </Suspense> */}
        </>
    )
}
export default withRouter(Routes)
